/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import {  Divider,TextField, InputAdornment } from "@material-ui/core";
import uiConf from "../../config/uiConf";
import { Search } from "@material-ui/icons";

import Dialog from "../dialog/functional/Dialog";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import AutoForm from "../form/functional/AutoForm";
import "../grid/layout/DataGridMomSysOrderPurchase.css"
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import DialogHeaderWithClose from "../dialog/functional/DialogHeaderWithClose";
import {debounce} from "lodash";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    input: {
      '& input[type=number]': {
          '-moz-appearance': 'textfield'
      },
      '& input[type=number]::-webkit-outer-spin-button': {
          '-webkit-appearance': 'none',
          margin: 0
      },
      '& input[type=number]::-webkit-inner-spin-button': {
          '-webkit-appearance': 'none',
          margin: 0
      }
    },
  });
  

function TkInsertStandardUnitPriceSearchDialog ( props ) {

    const {

        id,
        formId,
        moveable,
        resizable,
        fullWidth,
        maxWidth,

        onClose,
        onInitialized,
        onSuccess,
        
        title,

        ...others

    } = props;

    const { t } = useTranslation ();

    const classes = useStyles();


    const [data, setData] = useState({

        searchData : "",
        radioData  : ""

    });

    const radioButtonSchema = {

        name: "radioButtonSchema",
        type: "BASE TABLE",
        columns: [
            {
                name: "insertStandardPrice",
                type: "varchar(50)",
                formOrder: 1,
                formItemType: "radio",
                row: true,
                formControlStyle: { margin: 0, paddingTop: 0},
                selectItems: [
                    {
                        name: t("columnName.selfSupplyMaterialComplete"),
                        value: "selfSupplyMaterialComplete"
                    },
                    {
                        name: t("columnName.selfSupplyMaterialRoughGrinding"),
                        value: "selfSupplyMaterialRoughGrinding"
                    },
                    {
                        name: t("columnName.customerSupplyMaterialComplete"),
                        value: "customerSupplyMaterialComplete"
                    },
                    {
                        name: t("columnName.customerSupplyMaterialRoughGrinding"),
                        value: "customerSupplyMaterialRoughGrinding"
                    },
                    {
                        name: t("columnName.selfSupplyMaterialExcludeRappingCompelte"),
                        value: "selfSupplyMaterialExcludeRappingCompelte"
                    },
                    {
                        name: t("columnName.customerSupplyMaterialExcludeRappingComplete"),
                        value: "customerSupplyMaterialExcludeRappingComplete"
                    },
                ],
                width: "100%"
            }
        ]
    };

    const onRadioChange = ( radioData ) => {

        setData((prevData)=> {

            let newData = {
                ...prevData,
                radioData
            };

            return newData;

        })

    }
    const onSearchChange = debounce(( searchData ) => {

        setData((prevData)=> {

            let newData = {
                ...prevData,
                searchData
            };

            return newData;
        })

    }, 500);

    const onCloseDialog = () => {

        setData( {
            searchData : "",
            radioData  : ""
        } );
        
        if ( onClose ) {

            onClose ();

        }

    }


    const query = useMemo(() => {

        if(data.searchData && data.radioData.insertStandardPrice) {

            return {  
                $searchData: data.searchData,
                $radioData: data.radioData.insertStandardPrice,
             }
        }

    }, [data])

    return (
        <Dialog
            id={id}
            moveable={moveable ? moveable : uiConf.dialogMoveable}
            resizable={resizable ? resizable : uiConf.dialogResizable}
            fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
            maxWidth="lg"
            onClose={onCloseDialog}
            {...others}
        >

            <DialogHeaderWithClose>
                <DialogTitle>
                    { t ( "dialog.title.TkInsertStandardUnitPrice.insertCodeSearch" ) }
                </DialogTitle>
            </DialogHeaderWithClose>

            <Divider />

            <DialogContent style={{ height: "600px"}}>

                <ReflexContainer orientation="horizontal">

                <ReflexElement flex={0.25} >

                    <AutoForm
                        id={formId}
                        schema={radioButtonSchema}
                        onChange={onRadioChange} 
                        noAutoFocus
                    />
                
                        <TextField
                            className={classes.input} 
                            id={id}
                            autoFocus
                            type="number"
                            placeholder={t("common.search")}
                            style = {{paddingTop : "20px" ,width : "500px"}}
                            onChange={(e) => onSearchChange(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>                    
                                ),
                            }}
                        />
                    
                </ReflexElement>

                <ReflexSplitter
                    style={{height: "1px",color:"lightgray"}}
                />

                <ReflexElement flex={0.75} >

                    <BasicCrudScreenType
                        view = "TkVwSearchInsertStandardUnitPrice"
                        noSearch
                        noExcel
                        $queries={query}
                        noFilter
                    />

                </ReflexElement>

            </ReflexContainer>

            </DialogContent>
        </Dialog>

    );

}

export default TkInsertStandardUnitPriceSearchDialog;
